var ubian = ubian || {};
ubian.profile = {};

ubian.profile.deleteAccountClicked = false;
ubian.profile.changePasswordClicked = false;

ubian.profile.changeProfile = function () {

    if ($('.js-profile-save-changes').hasClass("disabled")){
        return;
    }

    $('#js-profile-form label').removeClass('.error');
    if (ubian.profile.validateProfileForm()) {
        var values = ubian.profile.getProfileValues();
        var valuesToPost = {
            name: values.profileName,
            surname: values.profileSurname,
            email: values.profileEmail,
            phone: values.profilePhone,
            login: values.profileLogin
        };

        $('.js-profile-save-changes').after(ubian.utils.loader());
        $('.js-profile-save-changes').addClass("disabled");
        var cb = function() { location.reload() };
        $.post(ubian.routes["user_update_profile"], valuesToPost)
            .done(function(result) {
                if (result.status === "ok"){
                    ubian.utils.alert(ubian.translate('User.Profile.ProfileChange'), null, null, cb, null, null);
                }
                if (result.status === "error"){
                    ubian.utils.alert(ubian.translate(result.code), null, null, cb, null, null);
                }
            })
            .fail(function(result) {
                if(result.error) {
                    ubian.utils.alert(ubian.translate(result.error), null, null, cb, null, null);
                }
            })
            .always(function() {
                $('.js-profile-save-group .js-loader-icon').remove();
            });
    };
}

ubian.profile.validateProfileForm = function () {
    var values = ubian.profile.getProfileValues();
    var hasErrors = false;
    if (values.profileName == "" || !/^[^<>@,;*!?]+$/.test(values.profileName)) {
        $("#js-profile-form #profile-name").parent().find('label').addClass('error');
        hasErrors = true;
    }

    if (values.profileSurname == "" || !/^[^<>@,;*!?]+$/.test(values.profileSurname)) {
        $("#js-profile-form #profile-surname").parent().find('label').addClass('error');
        hasErrors = true;
    }

    if (values.profileLogin == "" || !/^[\w-+\.]+@([\w-+]+\.)+[\w-]{2,4}$/.test(values.profileLogin)) {
        $("#js-profile-form #profile-login").parent().find('label').addClass('error');
        hasErrors = true;
    }

    if (values.profileEmail == "" || !/^[\w-+\.]+@([\w-+]+\.)+[\w-]{2,4}$/.test(values.profileEmail)) {
        $("#js-profile-form #profile-email").parent().find('label').addClass('error');
        hasErrors = true;
    }

    if (values.profilePhone.length > 0) {
        if (!/^[+]?[()/0-9. -]{9,}$/.test(values.profilePhone) && !/^(\+421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/.test(values.profileName)) {
            $("#js-profile-form #profile-phone").parent().find('label').addClass('error');
            hasErrors = true;
        };
    }

    return !hasErrors;
}

ubian.profile.getProfileValues = function () {
    var toRet = {
        profileName: $('#profile-name').val(),
        profileSurname: $('#profile-surname').val(),
        profileLogin: $('#profile-login').val(),
        profileEmail: $('#profile-email').val(),
        profilePhone: $('#profile-phone').val()
    };

    return toRet;
}

ubian.profile.checkProfileFormDisability = function () {
    var values = ubian.profile.getProfileValues();

    var isDisabled = true;
    if (values.profileName !== "" || values.profileName != $('#profile-name').val()) {
        return !isDisabled;
    }
    if (values.profileSurname !== "" || values.profileSurname != $('#profile-surname').val()) {
        return !isDisabled;
    }
    if (values.profileLogin !== "" || values.profileLogin != $('#profile-login').val()) {
        return !isDisabled;
    }
    if (values.profileEmail !== "" || values.profileEmail != $('#profile-email').val()) {
        return !isDisabled;
    }
    if (values.profilePhone !== "" || values.profileEmailprofilePhone != $('#profile-phone').val()) {
        return !isDisabled;
    }
}

ubian.profile.checkChangePasswordDisability = function () {

    var isDisabled = true;

    if ($('#password1').val() !== "") {
        isDisabled = false;
    }

    if ($('#password2').val() !== "") {
        isDisabled = false;
    }

    return isDisabled;
}

//Delete profile
ubian.profile.deleteProfile = function () {
    $.post(ubian.routes["user_remove_profile"], function (data) {
        if (data) {
            var messages = data.messages;
            $('.js-delete-account-info').addClass('d-none');
            $('.js-delete-btn-wrap').addClass('d-none');
            $('.js-delete-account-message-col').removeClass('col-md-8');

            $('.js-delete-account-messages').removeClass('d-none');
            $('.js-delete-account-messages').addClass('d-block');
            messages.forEach(function(message) {
                $('.js-delete-account-messages .messages').append('<p>' + message + '</p>');
            });
            $('.delete-account-buttons').removeClass('d-none');
        }
    });
}

//Cancel delete profile
$('.js-delete-profile-cancel').click(function () {
    ubian.profile.deleteAccountClicked = false;
    $('.js-delete-account-info').removeClass('d-none');
    $('.js-delete-btn-wrap').removeClass('d-none');
    $('.js-delete-account-message-col').addClass('col-md-12');
    $('.js-delete-account-messages').addClass('d-none');
    $('.js-delete-account-messages .messages').html('');
    $('.delete-account-buttons').addClass('d-none');
    $('.js-delete-account-messages').removeClass('d-block');
})

$('.js-delete-profile-confirm').click(function () {

    $.post(ubian.routes["user_delete_account"], function (result) {
        if (result) {
            var email = result.email;
            message = ubian.translate('User.Profile.DeleteAccount.ConfirmResult');
            var replacedMessage = message.replace("--val", email);
            $('.delete-account-buttons').addClass('d-none');
            $('.js-delete-account-messages').removeClass('d-none');
            $('.js-delete-profile-confirm-question').addClass('d-none');
            $('.js-delete-account-messages .messages').html('<p>' + replacedMessage + '</p>');

        }
        //error message is handled in app.js .ajaxError
    });
})


ubian.profile.setErrorMessage = function (result) {
    console.log('result', result);
    var message = '';
    if (result.error_code === 'DA-DANC-191') {
        message = ubian.translate('APIError.191');
    }
    if (result.error_code === 'DA-DANC-192') {
        message = ubian.translate('APIError.192');
    }
    if (result.error_code === 'DA-DANC-193') {
        message = ubian.translate('ApiError.193');
    }

    $('.delete-account-buttons').addClass('d-none');
    $('.js-delete-account-messages').removeClass('d-none');
    $('.js-delete-profile-confirm-question').addClass('d-none');
    $('.js-delete-account-messages .messages').html('<p>' + message + '</p>');

}

//change password

ubian.profile.changePassword = function () {
    ubian.profile.changePasswordClicked = true;

    var email = $("#profile-password-login-email").val();
    var password1 = $('#password1').val();
    var password2 = $('#password2').val();
    var message = false;

    if (password1 !== password2) {

        message = ubian.translate('User.Error.PasswordMismatch');

    }
    if (password1.length > 0) {
        if (password1.length > 0 && password1.length < 6) {
            message = ubian.translate('User.Error.PasswordShort');
        }
        if (!__ubian_password_regex.test(password1)) {
            message = ubian.translate('User.Error.PasswordFormat');
        }
    }

    if (!message) {
        //poste
        $('.js-change-password-message span').html("");
        $('.js-change-password-message').addClass('d-none');
        $("#password1").parent().find('label').removeClass("error");
        $("#password2").parent().find('label').removeClass("error");

        $.post(ubian.routes["user_change_password"], { password: password1, email: email }, function (
            result
        ) {
            if (result) {
                var translation = ubian.translate('User.Profile.ChangePassword.Result');
                translation = translation.replace("--val", result);
                ubian.utils.alert(ubian.translate(translation));
                $(".js-profile-change-password").addClass("disabled");
            }
            ubian.profile.changePasswordClicked = false;
            $('.change-password-box .js-loader-icon').remove();
        });

    } else {
        $('.js-change-password-message span').html(message);
        $('.js-change-password-message').removeClass('d-none');
        $("#password1").parent().find('label').addClass("error");
        $("#password2").parent().find('label').removeClass("error");
        ubian.profile.changePasswordClicked = false;
        $('.change-password-box .js-loader-icon').remove();
    }
}

ubian.profile.resendConfirmationEmail = function(){
    $.get(ubian.routes["user_resend_mail"], function(result){
        console.log('result', result);
        ubian.utils.alert(ubian.translate("User.Profile.ConfirmationResent"));
    });
}

//Green km
ubian.profile.setGreenKm = function(value){
    var setValue = value ? 1 : 0;
    console.log('value', setValue);
    $.post(ubian.routes['user_change_green_km'],{value: parseInt(setValue)}, function(result){
        ubian.utils.alert(ubian.translate("JS.Settings.Saved"),"", ubian.translate("Navigation.Button.OK"));
    })
}

$(function () {
    var profileForm = $('#js-profile-form');

    //resend mail
    $('.js-send-email').click(function(){
       ubian.profile.resendConfirmationEmail();
    })

    $("#js-profile-form input").keydown(function () {
        var disability = ubian.profile.checkProfileFormDisability();
        if (!disability) {
            $('.js-profile-save-changes').removeClass('disabled');
        } else {
            $('.js-profile-save-changes').addClass('disabled');
        }
    })

    $("#js-profile-form").submit(function () {
        $('#js-profile-form label').removeClass('error');
        ubian.profile.changeProfile();
        return false;
    })

    $(".js-delete-account").click(function () {
        if (ubian.profile.deleteAccountClicked) {
            return;
        }
        ubian.profile.deleteAccountClicked = true;
        ubian.profile.deleteProfile();
    })

    //change password
    $("#password1, #password2").keydown(function () {
        console.log("password hele");

        var disability = ubian.profile.checkChangePasswordDisability();
        if (!disability) {
            $('.js-profile-change-password').removeClass('disabled');
        } else {
            $('.js-profile-change-password').addClass('disabled');
        }
    })

    $(".js-profile-change-password").click(function () {
        if ($(this).hasClass('disabled')) {
            return;
        }

        if (ubian.profile.changePasswordClicked) {
            return;
        }

        $(".js-profile-change-password").after(ubian.utils.loader());
        ubian.profile.changePassword();
    })

    // $('.js-green-km-checkbox-label').click(function(e){
    //     e.preventDefault();
    // })

    $(".js-green-km-checkbox").change(function(){
        ubian.profile.setGreenKm($(this).is(":checked"));
        if( $(this).is(":checked")){
            $('.js-greenkm-info').removeClass('d-none');
            $('.js-greenkm-info').addClass('d-flex');
        } else {
            $('.js-greenkm-info').removeClass('d-flex');
            $('.js-greenkm-info').addClass('d-none');
        }
    })

    //settings
    $(".js-notifications-pcl, .js-notifications-card").click(function(){
        $('.js-notification-settings').removeClass('disabled');
    })


    $('.js-notification-settings').click(function(e){
        if ($(this).hasClass("disabled")){
            return e.preventDefault();
        }
    })

    // show delete account info
    $('.js-delete-account-more-info').click(function() {
        // Toggle more info for specific element
        // $(this).parent().parent().find(".del-acc-info").addClass("active");
        // $(this).remove);
        // Toggle for all - desktop, mobile
        $(".del-acc-info").addClass("active");
        $(".js-delete-account-more-info").remove();
    });
})
